import React from 'react';
import { Link } from "react-router-dom";

export default function Breadcrumb({ path }) {

  return (
    <nav aria-label="breadcrumb">
      <ol className="breadcrumb">
        <li className="breadcrumb-item">
          <Link to="/" target="_pg_blank"><i className="fa fa-home" /></Link>
        </li>
        {
          path.map((i) => {
            return (<li key={i} className="breadcrumb-item">
              <Link to="/" target="_pg_blank">{i}</Link>
            </li>)
          })
        }
      </ol>
    </nav>
  )
}